import type { FaireProductEntity } from "../../entity_types/product";

export const p_a7hy3hswf4: FaireProductEntity = {
  token: "p_a7hy3hswf4",
  type: "product",
  name: "Mini Penis Candles | Pride Decor | Pride Month | LGBTQ+ Gift",
  brandToken: "b_76xje4vy2k",
  brandName: "CandleSpiritCo | Soy Candles",
  imageUrl:
    "https://cdn.faire.com/fastly/9ae46ef8edfe2b03d74d64fecf73ea352667dec7e9b1f13045730e64205dab43.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0da02f2a0e8ab858bd8b3afa2cab2fa1df3a1c562f13534f15e643d8c2ce8b3a.jpeg",
    "https://cdn.faire.com/fastly/f6cbecd908b6eee80ebccaca9fb997fa7b65a6dd352ddbbd55dba4b14d367dda.jpeg",
    "https://cdn.faire.com/fastly/ae54d55294e13afe4aab5a8f4b4b3be8a32ada67e7772c2945792ced28c24fd8.jpeg",
    "https://cdn.faire.com/fastly/bb5cbffcea3075427bc6e6e755e86ce4c0e014a76df3baa699dc688e45d75d8d.jpeg",
  ],
  priceDollars: 1.27,
  description:
    "Our Mini Penis Candles are a playful and eye-catching addition to any celebration. These small novelty candles are sure to bring a playful touch and personality to hen parties and special occasions.\n\nIdeal for bachelor and bachelorette parties, birthdays, and fun gatherings. These candles look perfect as cake toppers, party decor, or memorable party favors. \n\nThese willy candles are also a great choice for a LGBTQ+ gift or a small present. Their vibrant rainbow colors also make them a bestseller during Pride month. \n\nSIZE: Height 7 cm (2.75 in)\n\nPackaging:\nEach soy candle is carefully wrapped in tissue paper and bubble wrap to ensure safe shipping. Gift boxes are not included\n\nWhy retailers love it:\n- Unique handmade design that stands out on shelves \n- Wide selection – over 20 long-lasting fragrances\n- Appeals to customers looking for unique gifts and home decor\n- Strong fit for seasonal displays and year-round decor\n\nOur candles are:\n- Handmade from natural soy wax, dyes, a cotton wick\n- Infused with premium fragrance oils \n- Eye-catching and highly detailed\n- Clean-burning\n- Produced in small batches",
  tags: [],
  msrpDollars: 2.54,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:55.954Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
